import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, CssBaseline, Typography } from '@mui/material';
import { di } from '../../state/inversify.config';
import { useQuerySync } from '../../state/queryParams/useQuerySync';
import { PlayersPageQueryService } from './playersPage.queryParam.service';
import { PlayersPageQuery } from './playersPage.queryParams.interface';
import { PlayerList } from './playerList';
import { AccountTypes } from '../../components/changeUser/accountTypes.enum';
import { AddPlayerDomain } from './addPlayer.domain';

interface PlayersPageProps {
  pageQuery: PlayersPageQueryService;
}
export function PlayersPage({ pageQuery }: PlayersPageProps) {
  useQuerySync<PlayersPageQuery>(pageQuery);
  const { t } = useTranslation();

  const addPlayerDomain = di.get(AddPlayerDomain);
  const accountType = addPlayerDomain.useAccountTypeSelector();

  return (
    <Container>
      <CssBaseline />
      <Typography
        id="player-title"
        variant="h5"
        component="h5"
        fontWeight="bold"
        sx={{ my: 1 }}
      >
        {accountType === AccountTypes.Clinic
          ? t('PATIENTS_LIST')
          : t('PLAYERS_LIST')}
      </Typography>
      <PlayerList />
    </Container>
  );
}
